import { coursConstants as emg } from "../../../constants/cours";

const initialState = { loading: true, list: [], data: null };

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case emg.GET_EMARGEMENTS:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case emg.GET_COUR:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    default:
      return state;
  }
}
